import React from 'react';
import SectionHeader from './SectionHeader';

export default function Education() {
  return (
    <section id="education" style={{ padding: '7rem 0', position: 'relative' }}>
      <div className="section-container">
        <SectionHeader
          label="Education & Certifications"
          title="Academic Background"
          subtitle="My educational foundation and professional certifications."
        />

        <div
          style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))',
            gap: '2rem',
            marginTop: '3rem',
          }}
        >
          {/* Education Card */}
          <div className="glass-card" style={{ padding: 0, overflow: 'hidden' }}>
            <div style={{ height: '3px', background: 'var(--gradient-primary)' }} />
            <div style={{ padding: '2rem' }}>
              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: '0.75rem',
                  marginBottom: '1.25rem',
                }}
              >
                <div
                  style={{
                    width: '48px',
                    height: '48px',
                    borderRadius: '12px',
                    background: 'rgba(139, 92, 246, 0.1)',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    fontSize: '1.5rem',
                  }}
                >
                  🎓
                </div>
                <div>
                  <h3
                    style={{
                      fontFamily: 'var(--font-display)',
                      fontSize: '1.15rem',
                      fontWeight: 700,
                      lineHeight: 1.3,
                    }}
                  >
                    B.Tech in Computer Science
                  </h3>
                  <p style={{ color: 'var(--text-muted)', fontSize: '0.85rem' }}>& Engineering</p>
                </div>
              </div>

              <div style={{ display: 'flex', flexDirection: 'column', gap: '0.75rem' }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                  <span style={{ color: 'var(--accent-violet-light)', fontWeight: 600, fontSize: '0.95rem' }}>
                    Amrita Vishwa Vidyapeetham
                  </span>
                </div>
                <div
                  style={{
                    display: 'flex',
                    gap: '1.5rem',
                    flexWrap: 'wrap',
                  }}
                >
                  <span
                    style={{
                      fontSize: '0.85rem',
                      color: 'var(--text-secondary)',
                      display: 'flex',
                      alignItems: 'center',
                      gap: '0.35rem',
                    }}
                  >
                    📅 2020 – 2024
                  </span>
                  <span
                    style={{
                      fontSize: '0.85rem',
                      color: 'var(--text-secondary)',
                      display: 'flex',
                      alignItems: 'center',
                      gap: '0.35rem',
                    }}
                  >
                    📍 Amritapuri, India
                  </span>
                </div>
                <div
                  style={{
                    display: 'inline-flex',
                    alignItems: 'center',
                    gap: '0.4rem',
                    padding: '0.4rem 0.85rem',
                    borderRadius: '8px',
                    background: 'rgba(16, 185, 129, 0.08)',
                    border: '1px solid rgba(16, 185, 129, 0.15)',
                    alignSelf: 'flex-start',
                  }}
                >
                  <span style={{ fontSize: '0.85rem', fontWeight: 700, color: '#10b981' }}>CGPA: 7.98</span>
                </div>
              </div>
            </div>
          </div>

          {/* Certifications Card */}
          <div className="glass-card" style={{ padding: 0, overflow: 'hidden' }}>
            <div style={{ height: '3px', background: 'var(--gradient-secondary)' }} />
            <div style={{ padding: '2rem' }}>
              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: '0.75rem',
                  marginBottom: '1.5rem',
                }}
              >
                <div
                  style={{
                    width: '48px',
                    height: '48px',
                    borderRadius: '12px',
                    background: 'rgba(6, 182, 212, 0.1)',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    fontSize: '1.5rem',
                  }}
                >
                  📜
                </div>
                <h3
                  style={{
                    fontFamily: 'var(--font-display)',
                    fontSize: '1.15rem',
                    fontWeight: 700,
                  }}
                >
                  Certifications
                </h3>
              </div>

              <div style={{ display: 'flex', flexDirection: 'column', gap: '1.25rem' }}>
                {[
                  {
                    name: 'React Basics',
                    issuer: 'Meta',
                    date: 'Feb 2024',
                    color: '#3b82f6',
                    bg: 'rgba(59, 130, 246, 0.08)',
                    border: 'rgba(59, 130, 246, 0.15)',
                  },
                  {
                    name: 'User Experience Design Professional Certificate',
                    issuer: 'Google',
                    date: 'Aug 2023',
                    color: '#10b981',
                    bg: 'rgba(16, 185, 129, 0.08)',
                    border: 'rgba(16, 185, 129, 0.15)',
                  },
                ].map((cert) => (
                  <div
                    key={cert.name}
                    style={{
                      padding: '1rem 1.25rem',
                      borderRadius: '12px',
                      background: cert.bg,
                      border: `1px solid ${cert.border}`,
                      transition: 'all 0.3s ease',
                    }}
                  >
                    <h4 style={{ fontWeight: 600, fontSize: '0.95rem', marginBottom: '0.35rem', lineHeight: 1.4 }}>
                      {cert.name}
                    </h4>
                    <div
                      style={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        flexWrap: 'wrap',
                        gap: '0.5rem',
                      }}
                    >
                      <span style={{ color: cert.color, fontWeight: 600, fontSize: '0.85rem' }}>
                        {cert.issuer}
                      </span>
                      <span
                        style={{
                          fontFamily: 'var(--font-mono)',
                          fontSize: '0.75rem',
                          color: 'var(--text-muted)',
                        }}
                      >
                        {cert.date}
                      </span>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
